<template>
    <el-select :key="selectKey" ref="selectDom" :placeholder="placeholder" @blur.native.capture="blur" v-model="selectedValue" clearable :filterable="filterable" :disabled="disabled" @change="handleChange">
        <el-option v-for="item in normalizedOptions" :key="item.optionValue" :label="item.Text" :value="item.optionValue">
            {{item.Text}}
        </el-option>
    </el-select>
</template>

<script type="text/javascript">
export default {
    name: "RtPicklist",
    props: {
        value: [String, Number],
        entity: {
            type: String,
            required: true
        },
        attribute: {
            type: String,
            required: true
        },
        disabled: {
            type: Boolean,
            default: false,
            required: false
        },
        placeholder: {
            type: String,
            default: '请选择'
        },
        filterable: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            selectedValue: null,
            options: [],
        }
    },
    computed: {
        normalizedOptions() {
            return this.options.map((item) => {
                return Object.assign({}, item, {
                    optionValue: this.normalizeValue(item.Value)
                });
            });
        },
        selectKey() {
            return [
                this.entity,
                this.attribute,
                this.selectedValue,
                this.normalizedOptions.length
            ].join("-");
        }
    },
    watch: {
        value(newVal, oldVal) {
            this.syncSelectedValue(newVal);
        }
    },
    methods: {
        normalizeValue(value) {
            if (value === null || value === undefined || value === "") {
                return value;
            }
            return String(value);
        },
        syncSelectedValue(value) {
            this.selectedValue = this.normalizeValue(value);
        },
        bindPicklist: function () {
            var self = this;
            rt.get("../api/crmpicklist/options/" + this.entity + "/" + this.attribute)
                .then(function (res) {
                    self.options = res;

                    // 发射 options-loaded 事件，允许父组件自定义处理选项
                    self.$emit("options-loaded", self.options);

                    self.$nextTick(function () {
                        self.syncSelectedValue(self.value);
                    });
                });
        },
        handleChange(val) {
            var selectedOption = this.normalizedOptions.find(function (item) {
                return item.optionValue === val;
            });
            var emitValue = selectedOption ? selectedOption.Value : val;

            this.$emit("input", emitValue);

            this.$emit("change", emitValue);
        },
        blur(){
            setTimeout(()=>{
                this.$refs.selectDom.blur();
            },300)
        }
    },
    mounted: function () {
        this.bindPicklist();
    }
}
</script>



// WEBPACK FOOTER //
// main.vue?42da3abe